<template>

    <transition :name="transitionName" @after-enter="afterAniamtion">
        <div v-if="(isActive || saved) && visible" class="c-tabs__section">
            <h4 v-show="title" class="c-tabs__section__title">{{ title }}</h4>
            <slot></slot>
            <form-row
                align="between"
                class="c-tabs__section__btns">
                <v-btn
                    class="c-tabs__section__btns-next"
                    :class="{ 'c-tabs__section__btns-next--hidden' : btnDisabled }"
                    type="green"
                    has-loader
                    :loading="isLoading"
                    @click="next">
                    {{ btnLabel }}
                </v-btn>
                <button
                    v-if="hasHistory"
                    class="c-tabs__section__btns-history"
                    @click="$emit('history')"
                    type="button"
                    tabindex="-1">
                    Historia zmian tego pola
                </button>
            </form-row>
        </div>
    </transition>

</template>


<script>

import {FormRow} from 'Components/Form'
import VBtn from 'Components/VBtn'
import zenscroll from 'zenscroll'
import noReact from 'Utils/NoReact'

export default {

    name: 'TabsSection',

    props: {
        title: String,
        disabled: Boolean,
        saved: Boolean,
        empty: Boolean,
        hasHistory: Boolean,
        btnDisabled: Boolean,
        btnLabel: {
            type: String,
            default: "Zapisz"
        },
        visible: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            sectionReady: false,
            watingToScroll: false,
            isLoading: false,
            isActive: this.saved,
            transitionName: null,
            nextClicked: false,
            parent: (typeof this.$parent.tabSections === 'undefined') ? this.$parent.$parent : this.$parent
        }
    },

    computed: {
        index() {
            return this.parent.tabSections.indexOf(this)
        },
        last() {
            return this.parent.tabSections.indexOf(this) === this.parent.tabSections.length - 1
        }
    },

    methods: {
        next() {
            this.isLoading = true
            this.$emit('next', this.after)
        },
        after(status = true) {
            this.isLoading = false
            if (status) {
                var nextSection = this.parent.tabSections[this.index + 1]
                if (nextSection) {
                    this.nextClicked = true
                    nextSection.isActive = true
                    nextSection.scrollToMe()
                }
            }
        },
        afterAniamtion() {
            this.sectionReady = true
            if (this.watingToScroll) {
                this.scrollToMe()
                this.watingToScroll = false
            }
        },
        scrollToMe() {
            if (this.sectionReady)
                this.parent.scrollToSection(this.index)
            else
                this.watingToScroll = true
        },
    },

    created() {
        this.parent.tabSections.push(this)
    },

    mounted() {
        //Do not animate first section
        this.sectionReady = noReact(this.isActive)
        if (this.index > 0)
            this.transitionName = 'tabs-s-fade-in'
    },

    beforeDestroy() {
        const index = this.parent.tabSections.indexOf(this)
        if (index >= 0) {
            this.parent.tabSections.splice(index, 1)
        }
    },

    components: {
        FormRow,
        VBtn
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-tabs__section {
    width: 100%;
    margin-bottom: 5rem;

    &__title {
        font-size: 1.1rem;
        font-weight: 500;
        width: 100%;
        color: $c-third;
        margin-bottom: 1.4rem;
    }
    &__btns {
        margin-top: 1rem !important;

        &-next {
            pointer-events: auto;
            opacity: 1;
            transition: opacity .3s ease-in-out;

            &--hidden {
                opacity: 0;
                pointer-events: none;
            }
        }
        &-history {
            cursor: pointer;
            background-color: transparent;
            border: none;
            outline: 0 !important;
            color: #637280;
            font-weight: 800;
            font-size: .8rem;
            height: 2.4rem;
            line-height: 2.4rem;
            padding-left: 2rem;
            padding-right: 1rem;
            background-image: url('#{$icons}/history.svg');
            background-position: 0 center;
            background-size: 1.3rem 1.3rem;
            background-repeat: no-repeat;
        }

        //Animations
    }
}
.tabs-s-fade-in-enter-active {
    transition: transform, opacity;
    transition-duration: .3s;
    transition-timing-function: cubic-bezier(0, .3, .25, 1);
}
.tabs-s-fade-in-enter {
    transform: translate3d(0, -50px, 0);
    position: absolute;
    top: 0;
    width: 100%;
    opacity: 0;
}

</style>
